/** @format */

import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as BoxArrowUpRight } from "bootstrap-icons/icons/box-arrow-up-right.svg";

const PlaceholderCard: React.FC = (...props) => {
  const { t: _ } = useTranslation();

  return (
    <div
      aria-hidden={true}
      {...props}
      style={{ opacity: "0.7" }}
      className="col pb-4 Resource"
    >
      <div className="card h-100 shadow">
        <div
          className="card-img-top border-bottom position-relative bg-secondary"
          style={{
            height: 0,
            paddingTop: "56.25%",
          }}
        >
          <div className="position-absolute top-0 left-0">
            <small
              className={`d-inline-block px-2 mt-2 rounded-end shadow-sm text-white placeholder bg-primary`}
            >
              &emsp;&emsp;&emsp;&emsp;&emsp;
            </small>
          </div>
        </div>
        <div className="card-body">
          <h5 className="card-title">
            <span className="placeholder col-10"></span>
          </h5>
          <div className="card-text mb-3">
            <span className="placeholder col-1"></span>
            &nbsp;
            <span className="placeholder col-4"></span>
            &nbsp;
            <span className="placeholder col-5"></span>
            &nbsp;
            <span className="placeholder col-6"></span>
            &nbsp;
            <span className="placeholder col-3"></span>
            &nbsp;
            <span className="placeholder col-1"></span>
            &nbsp;
            <span className="placeholder col-4"></span>
            &nbsp;
            <span className="placeholder col-5"></span>
            &nbsp;
            <span className="placeholder col-6"></span>
            &nbsp;
            <span className="placeholder col-3"></span>
            &nbsp;
          </div>

          <div className="btn-group" role="group">
            <button disabled className="btn btn-primary text-light">
              {_("Open resource")}
              &nbsp;
              <BoxArrowUpRight />
            </button>
            <button disabled className="btn btn-light btn-more-info">
              {_("More info")}
            </button>
          </div>
        </div>
        <div className="card-footer">
          <div className="text-muted">
            <small>
              {_("Published")}: <span className="placeholder col-3"></span>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderCard;
